import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hero-home" }
const _hoisted_2 = { class: "hero-home__inner" }
const _hoisted_3 = { class: "hero-home__content" }
const _hoisted_4 = { class: "hero-home__sub" }
const _hoisted_5 = { class: "hero-home__title" }
const _hoisted_6 = { class: "hero-home__subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "hero-home__desc"
}
const _hoisted_8 = { class: "hero-home__grid" }
const _hoisted_9 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($props.blockData.line_1), 1 /* TEXT */),
        _createElementVNode("h1", _hoisted_5, _toDisplayString($props.blockData.line_2), 1 /* TEXT */),
        _createElementVNode("h2", _hoisted_6, _toDisplayString($props.blockData.line_3), 1 /* TEXT */),
        ($props.blockData.desc)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($props.blockData.desc), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.blockData.cards, (card, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            href: card.url,
            class: "hero-home__card"
          }, [
            _createElementVNode("h3", null, _toDisplayString(card.title), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString(card.text), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_9))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}